import React from 'react';
import './Banner.scss';

const Banner = () => (
  <div className="banner-section">
    <div className="banner__title">
        В телевизорах LG обновляется<br/>
        программное обеспечение Smart TV.<br/>
        Ознакомьтесь с&nbsp;важной информацией<br/>
        по&nbsp;изменениям

      {/*  Уважаемый покупатель,<br />*/}
      {/*с 1 ноября в телевизорах LG обновляется программное обеспечение Smart TV.*/}
      {/*Ознакомьтесь с&nbsp;важной информацией&nbsp;по&nbsp;изменениям.*/}
    </div>
  </div>
);

export default Banner;
